import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ValidatorService } from '../base/table/validator.service';
import {TypeAttributesValidationService} from '../document-type-edit/document-type-edit.validator'
import { DocumentTypeAttribute } from '../models/documentTypeAttribute.model';
import { TableDataSource } from '../base/table/table-data-source';

@Component({
  selector: 'app-document-type-attribute-list',
  templateUrl: './document-type-attribute-list.component.html',
  styleUrls: ['./document-type-attribute-list.component.css'],
  providers:[{provide: ValidatorService, useClass: TypeAttributesValidationService }]
})
export class DocumentTypeAttributeListComponent implements OnInit {

  constructor(private attributeValidator: ValidatorService) { 

  }
  displayedColumns = ['actions','typeId', 'name'];

  @Input() attributeList;
  @Output() attributeListChange = new EventEmitter<DocumentTypeAttribute[]>();

  dataSource: TableDataSource<DocumentTypeAttribute>;


  ngOnInit() {
    this.dataSource = new TableDataSource<any>(this.attributeList, DocumentTypeAttribute, this.attributeValidator);
    this.dataSource.datasourceSubject.subscribe(attributeList => this.attributeListChange.emit(attributeList));
  }
  OnTypeSelected(r,e){
  }
}
